/**
 * Billing usage + the multi-tenant usage report. Both hit the mgmt API.
 */

import constants from '../../constants'
import axiosInstance from '../axiosInstance'
import { isAuthenticated } from '../../utils/authSession'
import { toServiceError } from './errors'
import {
  BillingCycleUsage,
  MetricsApp,
  MetricsServiceError,
  MultiTenantUsageResponse,
} from './types'

/**
 * Usage for the app's current billing cycle. Record holds seconds, URL needs ms.
 * Response is flat — no `data` envelope.
 */
export async function getBillingCycleUsage(
  app: MetricsApp,
): Promise<BillingCycleUsage | MetricsServiceError> {
  let URL = `${constants.customerDomain}apps/${app.id}/billing/`

  if (app.isAnnual && app.monthlyTermStart && app.monthlyTermEnd) {
    URL = `${URL}${app.monthlyTermStart * 1000}/${app.monthlyTermEnd * 1000}`
  } else {
    URL = `${URL}${(app.currentTermStart as number) * 1000}/${(app.currentTermEnd as number) *
      1000}`
  }

  return axiosInstance
    .post(`${URL}`, { appids: [app.id] })
    .then(res => res.data)
    .catch(toServiceError)
}

/**
 * EMAILS a usage report to the app owner — outward-facing, never call speculatively.
 * The unguarded catch can throw on network failure; see PROGRESS.md.
 */
export async function requestBillingUsage(
  postData: unknown,
  app: MetricsApp,
): Promise<MultiTenantUsageResponse | boolean> {
  const URL = `${constants.customerDomain}apps/${app.id}/usage`

  try {
    if (isAuthenticated()) {
      const res = await axiosInstance.post(URL, postData)
      return res.data
    }
  } catch (error) {
    return (error as { response: { data: MultiTenantUsageResponse } }).response.data
  }

  return false // Not authenticated — the call was never made
}

export default function init(): void {}
